import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column align-center",
      attrs: { "data-qa": "core-selection-drawer-error" },
    },
    [
      _c(VImg, {
        staticClass: "mb-3",
        attrs: {
          src: "/static/_v1/pd/pictures/ui-kit/cancel.svg",
          alt: _setup.t("Ничего не нашлось", _setup.options),
          width: "150",
          height: "150",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-h6 text--text mb-2" }, [
        _vm._v(
          "\n    " +
            _vm._s(_setup.t("Что-то пошло не так", _setup.options)) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-body-1 text-secondary--text mb-3" }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _setup.t(
                "Попробуйте немного подождать и обновите",
                _setup.options
              )
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        VBtn,
        {
          attrs: {
            depressed: "",
            color: "primary",
            "data-qa": "core-selection-drawer-error-btn-reload",
          },
          on: { click: _setup.reloadPage },
        },
        [
          _vm._v(
            "\n    " + _vm._s(_setup.t("Обновить", _setup.options)) + "\n  "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }